/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Suspense, useEffect, useState } from "react";
import { useContext } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Redirection from "../components/redirection/redirection-component";
import { getLocalStorage } from "../core/localStorageService";
import SignIn from "../modules/sign-in/sign-in";
import { AuthContext } from "../providers";
import { commonRoutes } from "./common-routes";
import LeftMenu from "../modules/common/leftMenu";

/*  eslint "require-jsdoc": ["error", {
      "require": {
          "FunctionDeclaration": true,
          "ArrowFunctionExpression": true,
          "FunctionExpression": true
      }
}] */
/**
 * @return {void}
 */
export default function RoutesGrit() {
  const { userInfo }: any = useContext(AuthContext);
  let allRoutes: any = [...commonRoutes];
  const [token, setToken] = useState<any>("")
  useEffect(() =>{
    const tkn = getLocalStorage("token") ? getLocalStorage("token") : "";
    setToken(tkn)
  },[token])

  // if (userInfo && userInfo.user_type === 1) {
  // if (userInfo.code === 'admin') {
  // 	allRoutes = allRoutes.concat(officeRoutes);
  // } else if (userInfo.code === 'sales_manager') {
  // 	allRoutes = allRoutes.concat(salesRoutes);
  // } else if (userInfo.code === 'care_manager') {
  // 	allRoutes = allRoutes.concat(careRoutes);
  // } else if (userInfo.code === 'md') {
  // 	allRoutes = allRoutes.concat(mdRoutes);
  // } else if (userInfo.code === 'health_coach') {
  // 	allRoutes = allRoutes.concat(healthRoutes);
  // }
  // } else {
  // 	clearLocalStorage();
  // }
  
  // alert(token)
  return (
    <>
      <BrowserRouter basename={process.env.REACT_APP_HOMEPAGE}>
      {/* {token && <LeftMenu />} */}
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            
            {allRoutes.map((route: any, i: number) =>
            <Route
                  path={route.path}
                  key={i}
                  element={<route.component />}
                />
              // route.private ? (
              //   token !=='' ? (
              //     <Route
              //       path={route.path}
              //       key={i}
              //       element={<route.component />}
              //     />
              //   ) : (
              //     <Route key={i} path="/login" element={<SignIn />}  />
              //   )
              // ) : (
              //   <Route
              //     path={route.path}
              //     key={i}
              //     element={<route.component />}
              //   />
              // )
            )}
			{/* <Redirection /> */}
			<Route path="*" element={<Redirection />}  />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}
